import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import courseReducer from '../features/course/redux/reducer';
import payReducer from '../features/pay/redux/reducer';
import centerReducer from '../features/center/redux/reducer';
import quesStoreReducer from '../features/ques-store/redux/reducer';
import topicReducer from '../features/topic/redux/reducer';
import styleOneReducer from '../features/style-one/redux/reducer';
import styleTwoReducer from '../features/style-two/redux/reducer';
import styleThreeReducer from '../features/style-three/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  course: courseReducer,
  pay: payReducer,
  center: centerReducer,
  quesStore: quesStoreReducer,
  topic: topicReducer,
  styleOne: styleOneReducer,
  styleTwo: styleTwoReducer,
  styleThree: styleThreeReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js